export default function useLocaleMessages(intl) {
    const localeMessage = (key, values) => {
        return intl.formatMessage({id: key}, values);
    }
    return localeMessage;
}
